import gql from "graphql-tag";

const businessFieldsFragment = gql`
  fragment BusinessFields on Business {
    id
    version
    status
    type
    externalId
    mfaEnabled
    mfaEnabledChange
    contact {
      id
      version
      companyName
      firstName
      middleName
      lastName
      photoId
      type
      emails {
        id
        version
        address
      }
      addresses {
        id
        version
        tags
        city
        line1
        state
        zipCode
      }
      phones {
        id
        version
        tags
        phoneNumber
      }
    }
  }
`;

const findBusinessesByNameQuery = gql`
  query findBusinessesByName(
    $business: BusinessInput
    $name: String = ""
    $startIndex: Int
    $stopIndex: Int
  ) {
    findBusinessesByName(
      business: $business
      name: $name
      pageable: {
        startIndex: $startIndex
        stopIndex: $stopIndex
        _type_: Range
        sort: { orders: [{ direction: "ASC", property: "id" }] }
      }
    ) {
      numberOfElements
      totalPages
      totalElements
      size
      number
      content {
        id
        version
        status
        contact {
          id
          version
          companyName
          photoId
        }
      }
    }
  }
`;

const findActiveBusinessesByNameQuery = gql`
  query($name: String = "", $startIndex: Int, $stopIndex: Int) {
    findActiveBusinessesByName(
      name: $name
      pageable: {
        startIndex: $startIndex
        stopIndex: $stopIndex
        _type_: Range
        sort: { orders: [{ direction: "ASC", property: "id" }] }
      }
    ) {
      numberOfElements
      totalPages
      totalElements
      size
      number
      content {
        id
        version
        status
        contact {
          id
          version
          companyName
          photoId
        }
        offices {
          id
          version
          contact {
            id
            alias
            companyName
          }
        }
      }
    }
  }
`;

const findBusinessByIdQuery = gql`
  query($id: UUID) {
    findBusinessById(id: $id) {
      ...BusinessFields
    }
  }
  ${businessFieldsFragment}
`;

const saveBusinessMutation = gql`
  mutation($business: BusinessInput) {
    saveBusiness2(business: $business) {
      ...BusinessFields
    }
  }
  ${businessFieldsFragment}
`;

const deleteBusinessMutation = gql`
  mutation($business: BusinessInput) {
    deleteBusiness(business: $business) {
      id
      version
    }
  }
`;

export {
  businessFieldsFragment,
  findBusinessesByNameQuery,
  findActiveBusinessesByNameQuery,
  findBusinessByIdQuery,
  saveBusinessMutation,
  deleteBusinessMutation
};
